import { CpdCredits } from './components/CpdCredits';
import { ResultsTitle } from './components/ResultsTitle';
import { ResultsDetails } from './components/ResultsDetails';
import { StarsPanel } from './components/StarsPanel';
import { PathwayLogo } from './components/PathwayLogo';
import { LogoWrapper } from './components/LogoWrapper';
import { InfoWrapper } from './components/InfoWrapper';
import { ButtonsBlock } from './components/ButtonsBlock';

export { default as TestResults } from './TestResults';

export {
  CpdCredits,
  ResultsTitle,
  ResultsDetails,
  StarsPanel,
  PathwayLogo,
  InfoWrapper,
  LogoWrapper,
  ButtonsBlock,
};
